export default __webpack_public_path__ + "static/media/(7)-Almendras-amargo.b44c0101.jpg";